import get from 'lodash/get';

export const getBreadcrumbs = (
  variant: Queries.VariantPageQuery['variant'],
) => {
  return get(variant, 'subcategory.category.department.title') !== undefined
    ? [
        {
          title: variant.subcategory.category.department.title,
          slug: variant.subcategory.category.department.slug,
        },
        {
          title: variant.subcategory.category.title,
          slug: variant.subcategory.category.slug,
        },
        {
          title: variant.subcategory.title,
          slug: variant.subcategory.slug,
        },
        {
          title: variant.productName,
          slug: undefined,
        },
      ]
    : [
        {
          title: variant.subcategory.category.title,
          slug: variant.subcategory.category.slug,
        },
        {
          title: variant.subcategory.title,
          slug: variant.subcategory.slug,
        },
        {
          title: variant.productName,
          slug: undefined,
        },
      ];
};
